export const AUTOPLAY_DELAY_SECONDS = 1000;
